import { Text } from '@growtherapy/sprout-ui';

import { GroupedResponse, MedicationValue, PrimaryCarePhysicianValue, QuestionTypeEnum } from './types';

type IntakeFormAnswerProps = {
  questionWithAnswer: GroupedResponse;
};

function formatPrimaryCarePhysician(pcp: PrimaryCarePhysicianValue | undefined): string {
  const fullName = [pcp?.client_pcp_first_name, pcp?.client_pcp_last_name]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
  return [fullName, pcp?.client_pcp_address?.trim()].filter(Boolean).join(', ');
}

export function IntakeFormAnswer({ questionWithAnswer }: IntakeFormAnswerProps) {
  const answer = questionWithAnswer.answer;

  if (answer === 'null') {
    return null;
  }

  const textClassName = 'rebrand:text-text-inverse';

  switch (questionWithAnswer.type) {
    case QuestionTypeEnum.SELECT:
      return <Text className={`text-small mb-2 ${textClassName}`}>{answer as string}</Text>;
    case QuestionTypeEnum.MEDICATION_INPUT:
      return (answer as MedicationValue[])?.map((a) => {
        return (
          <div className='pt-2 pb-2' key={a.medicationName}>
            <Text className={textClassName}>Medication: {a.medicationName}</Text>
            <Text className={textClassName}>Dosage: {a.dosage}</Text>
          </div>
        );
      });
    case QuestionTypeEnum.PRIMARY_CARE_PHYSICIAN_INPUT:
      return <Text className={textClassName}>{formatPrimaryCarePhysician(answer as PrimaryCarePhysicianValue)}</Text>;
    case QuestionTypeEnum.CHECKBOX:
    case QuestionTypeEnum.MULTI_SELECT:
      return <Text className={textClassName}>{(answer as string[])?.join(', ')}</Text>;
    default:
      return <Text className={textClassName}>{answer as string}</Text>;
  }
}

export default IntakeFormAnswer;
